/** Patron risk score colours — traditional scale (0 = low, 100 = max). See RISK_SCORE_USAGE_MAP.md */

export function riskLevelFromScore(score) {
  if (score == null || Number.isNaN(Number(score))) return null
  const s = Number(score)
  if (s >= 90) return 'CRITICAL'
  if (s >= 70) return 'HIGH'
  if (s >= 40) return 'MEDIUM'
  return 'LOW'
}

/** Prefer score-derived band when stored level is stale (post-migration 179). */
export function resolvedRiskLevel(score, level) {
  const fromScore = riskLevelFromScore(score)
  if (fromScore == null) return level || null
  const stored = level != null ? String(level).trim().toUpperCase() : ''
  if (!stored) return fromScore
  if (stored !== fromScore) return fromScore
  return stored
}

export function riskBandStyle(score, level) {
  const lvl = String(resolvedRiskLevel(score, level) || riskLevelFromScore(score) || '').toUpperCase()
  if (lvl === 'CRITICAL') return { color: '#991b1b', bg: '#fee2e2', border: '#fecaca' }
  if (lvl === 'HIGH') return { color: '#c2410c', bg: '#ffedd5', border: '#fed7aa' }
  if (lvl === 'MEDIUM') return { color: '#a16207', bg: '#fef9c3', border: '#fde047' }
  if (lvl === 'LOW') return { color: '#166534', bg: '#dcfce7', border: '#bbf7d0' }
  return { color: '#64748b', bg: '#f1f5f9', border: '#e2e8f0' }
}

export function formatRiskLabel(score, level) {
  const lvl = resolvedRiskLevel(score, level)
  if (score == null && !lvl) return '—'
  const scorePart = score != null ? formatRiskScoreNumber(score) : '—'
  const lvlPart = lvl ? String(lvl).charAt(0) + String(lvl).slice(1).toLowerCase() : '—'
  return `${scorePart} · ${lvlPart}`
}

/** Consistent numeric risk display (header + card both use this). */
export function formatRiskScoreNumber(score) {
  const n = Number(score)
  if (!Number.isFinite(n)) return '—'
  return Math.abs(n % 1) < 0.05 ? String(Math.round(n)) : n.toFixed(1)
}
